"use strict";

var _$isCancel_6 = function (value) {
  return !(!value || !value.__CANCEL__);
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlzQ2FuY2VsLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsInZhbHVlIiwiX19DQU5DRUxfXyJdLCJtYXBwaW5ncyI6IkFBQUEsWUFBQSxDQUFBOztBQUVBQSxnQkFBQUEsR0FBaUIsVUFBa0JDLEtBQWxCLEVBQWtCQTtFQUNqQyxPQUFBLEVBQUEsQ0FBVUEsS0FBVixJQUFVQSxDQUFTQSxLQUFBQSxDQUFNQyxVQUF6QixDQUFBLENBQUE7Q0FERkYsQ0FBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==